// user.reducer.js
import { useReducer } from "react";
import * as ACTION from "./types";

const initialState = {
  isLoading: false,
  showLeftMenu: false,
  showRigtMenu: false,
  business360EditMode: false,
  activeDashboardVersion: null,
  business360Data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.UPDATE_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case ACTION.UPDATE_LEFT_MENU:
      return {
        ...state,
        showLeftMenu: action.payload,
      };
    case ACTION.UPDATE_RIGHT_MENU:
      return {
        ...state,
        showRigtMenu: action.payload,
      };
    case ACTION.UPDATE_BUSINESS_360_EDIT_MODE:
      return {
        ...state,
        business360EditMode: action.payload,
      };
    case ACTION.UPDATE_BUSINESS_360_ACTIVE_VERSION:
      return {
        ...state,
        activeDashboardVersion: action.payload,
      };
    case ACTION.UPDATE_BUSINESS_360_DATA:
      return {
        ...state,
        business360Data: action.payload,
      };
    default:
      return state;
  }
};

const useAppReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    dispatch,
  };
};

export default useAppReducer;
